import * as React from 'react';
export const SvgProjectwise = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M14.222 0H1.778A1.778 1.778 0 000 1.778v12.444A1.778 1.778 0 001.778 16h12.444A1.778 1.778 0 0016 14.222V1.778A1.778 1.778 0 0014.222 0zm-8.56 3.778l-.942 1.12 4.596 1.324L8 7.884 3.28 6.542l-.978 1.13-.809-2.614zM2.027 13.44l-.8-2.613 1.44.382 3.11-3.751 2.054.586-3.049 3.716 1.44.4zm8.31-1.218l.943-1.12-4.596-1.324L8 8.116l4.684 1.342.978-1.13.81 2.614zm2.996-7.43l-3.11 3.75-2.054-.595 3.049-3.716-1.44-.391 4.16-1.28.8 2.613z" />
  </svg>
);
export default SvgProjectwise;
